import { render, staticRenderFns } from "./InformationBallon.vue?vue&type=template&id=716fd3ca&"
import script from "./InformationBallon.vue?vue&type=script&lang=js&"
export * from "./InformationBallon.vue?vue&type=script&lang=js&"
import style0 from "./InformationBallon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports